<template>
	<div class="wa-preview" :title="testo">
		<v-icon v-if="uscente" x-small :color="spunta.color" class="mr-1">{{ spunta.icon }}</v-icon>
		<v-icon v-if="iconaTipo" x-small class="mr-1">{{ iconaTipo }}</v-icon>
		<span class="wa-preview-text">{{ testo }}</span>
	</div>
</template>

<script>
import { isOutgoing, statusIcon, typeIcon, previewText } from './chat-helpers';

// anteprima compatta dell'ultimo messaggio (lista chat): spunte + icona tipo + testo su 2 righe
export default {
	name: 'MessagePreview',
	props: {
		message: { type: Object, required: true },
		contact: { type: String, default: '' },
	},
	computed: {
		uscente() {
			return isOutgoing(this.message, this.contact);
		},
		spunta() {
			return statusIcon(this.message.message_status);
		},
		iconaTipo() {
			return typeIcon(this.message.type);
		},
		testo() {
			return previewText(this.message);
		},
	},
};
</script>

<style scoped>
.wa-preview {
	display: flex;
	align-items: flex-start;
	font-size: 13px;
	line-height: 1.35;
	min-width: 0;
	max-width: 360px;
}
.wa-preview .v-icon {
	margin-top: 2px;
}
.wa-preview-text {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	word-break: break-word;
}
</style>
